import { Base64 } from 'js-base64';

export const base64 = { encode, decode: Base64.decode };

interface EncodeOptions {
  urlSafe?: boolean;
}

function encode(input: string, options: EncodeOptions = {}): string {
  const { urlSafe = false } = options;
  return Base64.encode(input, urlSafe);
}
